import * as React from 'react';

function SvgTime(props) {
    return (React.createElement("svg", Object.assign({ width: "24", height: "24", fill: "none", viewBox: "0 0 24 24" }, props),
        React.createElement("path", { fill: "currentColor", d: "M12 2.001c-5.523 0-10 4.477-10 10s4.477 10 10 10 10-4.477 10-10-4.477-10-10-10zm4.615 11.538H12a.769.769 0 01-.77-.769V5.847a.77.77 0 111.54 0v6.154h3.845a.769.769 0 110 1.538z" })));
}

export default SvgTime;
